import { defineMessages } from "react-intl";

export const messages = defineMessages({
	sendInvitation: {
		id: "form.send_invitation",
		defaultMessage: "Meghívó küldése"
	},
	sendInvitationSuccess: {
		id: "form.send_invitation.success",
		defaultMessage: "Meghívó elküldve"
	},
	emailAlreadyExists: {
		id: "form.send_invitation.email_already_exists",
		defaultMessage: "A megadott email cím már használatban van!"
	},
	title: {
		id: "form.send_invitation.title",
		defaultMessage: "Titulus"
	},
	firstName: {
		id: "form.send_invitation.first_name",
		defaultMessage: "Keresztnév"
	},
	lastName: {
		id: "form.send_invitation.last_name",
		defaultMessage: "Vezetéknév"
	},
	email: {
		id: "form.send_invitation.email",
		defaultMessage: "Email cím"
	},
	role: {
		id: "form.send_invitation.role",
		defaultMessage: "Szerepkör"
	},
	phoneNumber: {
		id: "form.send_invitation.phone_number",
		defaultMessage: "Telefonszám"
	},
	occupation: {
		id: "form.send_invitation.occupation",
		defaultMessage: "Foglalkozás"
	},
	stampNumber: {
		id: "form.send_invitation.stamp_number",
		defaultMessage: "Pecsétszám"
	},
	language: {
		id: "form.send_invitation.language",
		defaultMessage: "Nyelv"
	},
	emailRequired: {
		id: "form.send_invitation.email.error.required",
		defaultMessage: "Az email cím kötelező."
	},
	emailFormat: {
		id: "form.send_invitation.email.error.format",
		defaultMessage: "Az email cím formátuma nem megfelelő."
	},
	roleRequired: {
		id: "form.send_invitation.role.error.required",
		defaultMessage: "A szerepkör kötelező."
	},
	phoneNumberFormat: {
		id: "form.send_invitation.phone_number.error.format",
		defaultMessage: "A telefonszám formátuma nem megfelelő."
	},
	stampNumberFormat: {
		id: "form.send_invitation.stamp_number.error.format",
		defaultMessage: "A pecsétszám formátuma nem megfelelő."
	}
});
